$(document).ready(function() {
$('.customerLvmainSlide').slick({
  infinite: true,
   speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
});
})

$(document).ready(function() {
$('.OuterCvRte').slick({
rows: 2,
infinite: true,
speed: 300,
slidesToShow: 1
 }); 
})


$(document).ready(function () {
    var counted = 0;
    $(window).scroll(function () {
        var oTop = $(".countReviewBox").offset().top - window.innerHeight;
        if (counted == 0 && $(window).scrollTop() > oTop) {
            $(".count.percent").each(function () {
                var $this = $(this);
                var countTo = parseInt($this.attr("data-count").replace(/,/g, "")); // Remove commas & convert to number

                $({ countNum: 0 }).animate(
                    { countNum: countTo },
                    {
                        duration: 2000,
                        easing: "swing",
                        step: function () {
                            $this.text(numberWithCommas(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $this.text(numberWithCommas(this.countNum));
                        },
                    }
                );
            });
            counted = 1;
        }
    });

    // Function to format numbers with commas
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
});


